import axios from 'axios';
import { Dispatch } from 'redux';
import GALLERY_TYPES from './types';
import { ENV_CONFIG } from 'config/environment';
import API_ROUTES from 'services/apiRoutes';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};

export const getGalleryItems =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(GALLERY_TYPES.galleryStart());

    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.GET_GALLERY_ITEMS}`;

    try {
      const response = await axios.get(url, {
        headers: { ...headers, 'X-API-Key': process.env.REACT_APP_API_KEY },
      });
      dispatch(GALLERY_TYPES.gallerySuccess(response.data));
    } catch (error: any) {
      dispatch(GALLERY_TYPES.galleryError(error.message));
    }
  };
